import e from"./useFilePreview.js";import r from"./useItemsTransition.js";var IMAGE_TRANSITION_INTERVAL=5e3;function useImagesTransition(s){return e(r(null!=s?s:[],{interval:IMAGE_TRANSITION_INTERVAL}))}export{useImagesTransition as default};
//# sourceMappingURL=useImagesTransition.js.map
